import request from '@utils/request';

import {
  hideLoadingModal,
  showLoadingModal,
} from '@actions/loadingModal';

const PREFIX = '[CASES]';

export const GET_CASES_REQUEST = `${PREFIX} GET_CASES_REQUEST`;
export const GET_CASES_SUCCESS = `${PREFIX} GET_CASES_SUCCESS`;
export const GET_CASES_FAILURE = `${PREFIX} GET_CASES_FAILURE`;

const getCasesRequest = () => ({
  type: GET_CASES_REQUEST,
});

const getCasesSuccess = payload => ({
  type: GET_CASES_SUCCESS,
  payload,
});

const getCasesFailure = () => ({
  type: GET_CASES_FAILURE,
});

export const getCases = (params = {}) => (dispatch) => {
  dispatch(getCasesRequest());
  showLoadingModal(dispatch);

  return request
    .get('v1/cases/', { params })
    .then(({ data }) => dispatch(getCasesSuccess(data)))
    .catch((error) => {
      dispatch(getCasesFailure());

      throw error;
    })
    .finally(() => hideLoadingModal(dispatch));
};

export const SET_SORT_BY = `${PREFIX} SET_SORT_BY`;

const setSortByToStore = sortBy => ({
  type: SET_SORT_BY,
  sortBy,
});

export const setSortBy = (
  {
    target: {
      value: sortBy,
    } = {},
  } = {},
  searchQuery
) => (dispatch) => {
  dispatch(setSortByToStore(sortBy));

  dispatch(getCases({
    search: searchQuery || null,
    sort_by: sortBy || null,
  }));
};

export const SET_SEARCH_QUERY = `${PREFIX} SET_SEARCH_QUERY`;

const setSearchQueryToStore = searchQuery => ({
  type: SET_SEARCH_QUERY,
  searchQuery,
});

export const setSearchQuery = (
  {
    target: {
      value: searchQuery,
    } = {},
  } = {},
  sortBy
) => (dispatch) => {
  dispatch(setSearchQueryToStore(searchQuery));

  dispatch(getCases({
    search: searchQuery || null,
    sort_by: sortBy || null,
  }));
};



// WEBPACK FOOTER //
// ./src/store/actions/cases.js